import axios from '../axios-trips';

const logError = (access_token, error, errorType) => {
  axios({
    method: 'post',
    data: { error: error, errorType: errorType },
    url: '/api/v1/error',
    headers: {'Authorization': 'Bearer ' + access_token},
  })
  .then(response => {

  })
  .catch(error => {
    console.log(error);
  });
}

export default logError;



// WEBPACK FOOTER //
// ./src/store/LogError.js